import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { first, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { LanguageService } from '../utils/language.service';

@Injectable()
export class LangInterceptor implements HttpInterceptor {

  constructor(private languageService: LanguageService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.languageService.getLanguage().pipe(
      first(),
      switchMap((lang) => {
        if (!!lang) {
          const headers = req.headers.set('Accept-Language', `${lang},en;q=0.8,*;q=0.1`);
          req = req.clone({ headers });
        }
        return next.handle(req.clone());
      }),
    );
  }
}
